import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "tab", "panel" ]

  initialize() {
    this.showTab()
  }

  change(event) {
    this.index = this.tabTargets.indexOf(event.currentTarget)
  }

  showTab() {
    this.tabTargets.forEach((tab, index) => {
      const panel = this.panelTargets[index]
      tab.classList.toggle("text-blue-700", index == this.index)
      tab.classList.toggle("border-t", index == this.index)
      tab.classList.toggle("border-l", index == this.index)
      tab.classList.toggle("border-r", index == this.index)
      tab.classList.toggle("rounded-t", index == this.index)
      tab.classList.toggle("text-blue-500", index != this.index)
      tab.classList.toggle("hover:text-blue-800", index != this.index)
      panel.classList.toggle("hidden", index == this.index)
      panel.classList.toggle("hidden", index != this.index)
      
      for (let input of panel.getElementsByTagName('input')) {
        if (index != this.index) {
          input.setAttribute('disabled', true)
        } else {
          input.removeAttribute('disabled')
        }
      }
    })
  }

  get index() {
    return parseInt(this.data.get("index") || 0)
  }

  set index(value) {
    this.data.set("index", value)
    this.showTab()
  }
}
